'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeIcon = function (_React$Component) {
    _inherits(HomeIcon, _React$Component);

    function HomeIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, HomeIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HomeIcon.__proto__ || Object.getPrototypeOf(HomeIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'home-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24.001 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_12', transform: 'translate(-47.999 -48.46)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'house-nature' },
                        _react2.default.createElement('path', { fill: color, id: 'Shape_32', d: 'M51.5,55.68H56a2.4,2.4,0,1,0,0-4.8,2.394,2.394,0,0,0-.924.169.312.312,0,0,1-.245,0,.293.293,0,0,1-.166-.173,3.552,3.552,0,0,0-4.18-1.775,3.357,3.357,0,0,0-2.445,3.707A3.458,3.458,0,0,0,51.5,55.68Z' }),
                        _react2.default.createElement('path', { fill: color, id: 'Shape_33', d: 'M69.25,70.08H71A.961.961,0,1,1,71,72H49a.986.986,0,0,1-.985-.853.964.964,0,0,1,.763-1.041A.256.256,0,0,0,49,69.868V65.76c0-.187-.145-.02-.145-.02a.515.515,0,0,1-.708,0,.467.467,0,0,1,0-.68l1-.96,5.146-4.94a1.03,1.03,0,0,1,1.414,0l5.147,4.94,1,.96a.467.467,0,0,1,0,.68.515.515,0,0,1-.708,0S61,65.63,61,65.766V69.84a.245.245,0,0,0,.25.24h6a.245.245,0,0,0,.25-.24V61.5a.5.5,0,0,0-1,0V64.91c0,.125-.1.185-.173.125s-.473-.455-.473-.455a.515.515,0,0,0-.708,0,.467.467,0,0,0,0,.68l1.281,1.229a.234.234,0,0,1,.073.17v1.693a.242.242,0,0,1-.1.189.263.263,0,0,1-.216.044A3.974,3.974,0,0,1,63,64.92c0-1.621,2.666-7.7,3.812-10.25a.8.8,0,0,1,1.375,0C69.334,57.215,72,63.3,72,64.92a3.9,3.9,0,0,1-2.835,3.549.234.234,0,0,0-.165.219V69.84A.245.245,0,0,0,69.25,70.08Zm-13,0a.245.245,0,0,0,.25-.24V67.32a.981.981,0,0,0-1-.96h-1a.981.981,0,0,0-1,.96v2.52a.245.245,0,0,0,.25.24Z', fillRule: 'evenodd' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(HomeIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return HomeIcon;
}(_react2.default.Component);

exports.default = HomeIcon;